import {GET, POST} from '../index'

// 获取banner列表
export const getList = (data) => {
  return GET('/banner/list', data)
}

// 改变可见状态
export const changeStatus = (data) => {
  return POST('/banner/change/status', data)
}
// 更改排序
export const changeSort = (data) => {
  return POST('/banner/change/sort', data)
}

// 删除banner
export const delBanner = (data) => {
  return POST('/banner/del', data)
}

// 新增banner
export const addBanner = (data) => {
  return POST('/banner/add', data)
}

// 获取banner信息
export const getInfo = (data) => {
  return GET('/banner/info', data)
}

// 新增banner
export const editBanner = (data) => {
  return POST('/banner/edit', data)
}



// WEBPACK FOOTER //
// ./src/api/banner/index.js